module.exports = __webpack_public_path__ + "static/media/nina_carducci_desktop.311e0003.webp";